import { Article } from '@repo/types';
import API from '../endpoints';
import { QueryFunction, useQuery } from '@tanstack/react-query';
import axios from 'axios';
import { getAccessToken } from '../utils/getAccessToken';

// 30 minutes cache for article detail query
const CACHE_TIME = 30 * 60 * 1000;

export const useArticleBySlug = (slug: string | undefined) => {
  return useQuery({
    queryKey: ['article', { slug: slug! }],
    queryFn: fetchArticleBySlug,
    staleTime: !getAccessToken() ? CACHE_TIME : undefined,
    enabled: !!slug,
  });
};

export const fetchArticleBySlug: QueryFunction<Article | null, [string, { slug: string }]> = async ({ queryKey }) => {
  const [, { slug }] = queryKey;
  const accessToken = getAccessToken();
  const { data } = await axios.get<Article | null>(`${API.endpoints.articles}/${slug}`, {
    headers: accessToken
      ? {
          Authorization: `Bearer ${accessToken}`,
        }
      : {},
  });
  return data;
};

export const fetchArticleBySlugMeta = async (slug: string) => {
  const accessToken = getAccessToken();
  const { data } = await axios.get<Article | null>(`${API.endpoints.articles}/${slug}`, {
    headers: accessToken
      ? {
          Authorization: `Bearer ${accessToken}`,
        }
      : {},
  });
  return data;
};
